module.exports = __webpack_public_path__ + "img/connect_tiktok_shop.cbfd0bb5.png";